export default "__VITE_ASSET__WGPOJwmX__"